export default function selectCombatantResponseCollection(
  primaryCollection,
  secondaryCollection,
  tertiaryCollection,
) {
  const collections = [primaryCollection, secondaryCollection, tertiaryCollection].filter(
    Array.isArray,
  )

  const firstNonEmptyCollection = collections.find((collection) => collection.length > 0)

  if (firstNonEmptyCollection) {
    return firstNonEmptyCollection
  }

  return collections[0] || []
}
